import { render, staticRenderFns } from "./customerArticles.vue?vue&type=template&id=0ddcba7b&scoped=true"
import script from "./customerArticles.vue?vue&type=script&lang=js"
export * from "./customerArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcba7b",
  null
  
)

export default component.exports